import { useEffect, useState } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';

// export default function useBloodGroupList(
//     isLoaded,
//     setBloodGroup,
//     setSelectedBloodGroup,
//     setBloodGroupID,
//     handleMessage,
//     setIsBloodGroupLoaded
// ) {
//     useEffect(() => {
//         if (!isLoaded) {
//             const para = {
//                 p_companyid: localStorage.getItem('companyid'),
//             };

//             callApi(API_ENDPOINTS.BLOOD_GROUP_GET, 'POST', { 'Content-Type': 'application/json' }, para)
//                 .then(data => {
//                     if (Array.isArray(data) && data.length > 0) {
//                         setBloodGroup(data);
//                         setSelectedBloodGroup(data[0]);
//                         setBloodGroupID(data[0].id);
//                         setIsBloodGroupLoaded(true);
//                     } else {
//                         setBloodGroup([]);
//                     }
//                 })
//                 .catch(error => {
//                     handleMessage('error', error.message, 'Error');
//                 });
//         }
//     }, [isLoaded, setBloodGroup, setSelectedBloodGroup, setBloodGroupID, handleMessage]);
// }


const useBloodGroupList = ({ editID, handleMessage }) => {
    const [isLoad, setIsLoad] = useState(false);
    const [bloodGroup, setBloodGroup] = useState([]);
    const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
    const [bloodGroupID, setBloodGroupID] = useState(0);

    // ✅ Async fetch function
    const fetchBloodGroupList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await callApi(
                API_ENDPOINTS.BLOOD_GROUP_GET,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (Array.isArray(data) && data.length > 0) {
                setBloodGroup(data);

                const initialDesignation = data.find((dept) => dept.id === selectedID);

                if (initialDesignation) {
                    setSelectedBloodGroup(initialDesignation);
                    setBloodGroupID(initialDesignation.id);
                }
            } else {
                setBloodGroup([]);
            }

            setIsLoad(true);
        } catch (error) {
            handleMessage("error", error.message || "Something went wrong", "Error");
        }
    };

    // ✅ Proper useEffect
    useEffect(() => {
        if (!isLoad && editID === 0) {
            fetchBloodGroupList();
        }
    }, [isLoad, editID]);

    // ✅ Public loader
    const loadBloodGroupByID = async (selectedID) => {
        await fetchBloodGroupList(selectedID);
    };

    return {
        bloodGroup,
        selectedBloodGroup,
        bloodGroupID,
        setBloodGroup,
        setSelectedBloodGroup,
        setBloodGroupID,
        loadBloodGroupByID,
    };
};

export default useBloodGroupList;

